export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <img src="/logo.png" alt="Lakes Area Sealcoating" className="w-48 mb-6 object-contain" />
            <p className="text-gray-400 mb-6 leading-relaxed">Professional driveway sealcoating, commercial lot sealcoating, and parking lot striping serving Walworth County, Wisconsin.</p>
            <div className="space-y-4">
              {[
                { icon:'ri-phone-fill', label:'Call or Text', value:'(262) 215-0688', href:'tel:262-215-0688' },
                { icon:'ri-mail-fill', label:'Email', value:'info@lakesareaseal.com', href:'mailto:info@lakesareaseal.com' },
                { icon:'ri-map-pin-fill', label:'Serving', value:'Walworth County, WI', href:'' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-white text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs uppercase tracking-widest">{item.label}</p>
                    {item.href ? <a href={item.href} className="text-white font-bold hover:text-orange-400 transition-colors">{item.value}</a> : <p className="text-white font-bold">{item.value}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-display text-xl font-bold text-white uppercase mb-6 tracking-wide">Our Services</h4>
            <ul className="space-y-3">
              {['Driveway Sealcoating','Crack Filling & Repair','Full Maintenance Package','Commercial Lot Sealcoating','Parking Lot Striping','Free Estimates'].map(s => (
                <li key={s}><a href="#services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">{s}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-xl font-bold text-white uppercase mb-6 tracking-wide">Service Areas</h4>
            <ul className="space-y-3">
              {['Elkhorn, WI','Lake Geneva','Williams Bay','Fontana-on-Geneva Lake','Delavan','Sharon','Walworth','East Troy'].map(a => (
                <li key={a} className="flex items-center gap-2 text-gray-400 text-sm">
                  <i className="ri-map-pin-2-line text-orange-500 text-xs"></i>{a}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-12 text-center">
          <h4 className="font-display text-4xl font-bold text-white uppercase mb-4">Ready to Protect Your Pavement?</h4>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto">Driveways and commercial lots — free estimates, fast response.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:262-215-0688" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all inline-flex items-center justify-center gap-2">
              <i className="ri-phone-fill"></i>Call (262) 215-0688
            </a>
            <a href="#contact" className="border-2 border-white/20 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-white hover:text-black transition-all inline-flex items-center justify-center gap-2">
              <i className="ri-calculator-line"></i>Get Free Quote
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 bg-black/80">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-500 text-sm">© {currentYear} Lakes Area Sealcoating · <a href="https://lakesareaseal.com" className="hover:text-orange-400 transition-colors">lakesareaseal.com</a></div>
          <div className="flex items-center gap-5">
            <a href="https://www.facebook.com/profile.php?id=61563922962661" target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center hover:bg-orange-500 hover:border-orange-500 transition-all">
              <i className="ri-facebook-fill text-white text-sm"></i>
            </a>
            <span className="text-gray-500 text-sm">Licensed & Insured · Walworth County, WI</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
